import React, { useState } from "react";
import "../css/FeeStructure.css";

const FeeStructure = () => {
  const [selectedClass, setSelectedClass] = useState("Nursery");

  const feeData = {
    Nursery: {
      registration: 500,
      admission: 8000,
      annual: 6500,
      tuition: 2500,
      exam: 1500,
      transport: 1200,
      total: 45200,
    },

    "L.K.G.": {
      registration: 500,
      admission: 8500,
      annual: 7000,
      tuition: 2800,
      exam: 1500,
      transport: 1200,
      total: 48900,
    },

    "U.K.G.": {
      registration: 500,
      admission: 9000,
      annual: 7000,
      tuition: 3000,
      exam: 1500,
      transport: 1200,
      total: 51000,
    },

    "Class 1": {
      registration: 500,
      admission: 10000,
      annual: 8000,
      tuition: 3200,
      exam: 1800,
      transport: 1500,
      total: 57000,
    },

    "Class 2": {
      registration: 500,
      admission: 10000,
      annual: 8000,
      tuition: 3200,
      exam: 1800,
      transport: 1500,
      total: 57000,
    },

    "Class 3": {
      registration: 500,
      admission: 10000,
      annual: 8000,
      tuition: 3200,
      exam: 1800,
      transport: 1500,
      total: 57000,
    },

    "Class 4": {
      registration: 500,
      admission: 10000,
      annual: 8000,
      tuition: 3200,
      exam: 1800,
      transport: 1500,
      total: 57000,
    },

    "Class 5": {
      registration: 500,
      admission: 10000,
      annual: 8000,
      tuition: 3200,
      exam: 1800,
      transport: 1500,
      total: 57000,
    },

    "Class 6": {
      registration: 500,
      admission: 11000,
      annual: 8500,
      tuition: 3500,
      exam: 2000,
      transport: 1700,
      total: 61000,
    },

    "Class 7": {
      registration: 500,
      admission: 11000,
      annual: 8500,
      tuition: 3500,
      exam: 2000,
      transport: 1700,
      total: 61000,
    },

    "Class 8": {
      registration: 500,
      admission: 11000,
      annual: 8500,
      tuition: 3500,
      exam: 2000,
      transport: 1700,
      total: 61000,
    },

    "Class 9": {
      registration: 500,
      admission: 12000,
      annual: 9000,
      tuition: 4000,
      exam: 2200,
      transport: 1800,
      total: 67000,
    },

    "Class 10": {
      registration: 500,
      admission: 12000,
      annual: 9000,
      tuition: 4000,
      exam: 2200,
      transport: 1800,
      total: 67000,
    },
  };
  return (
    <>
      {}

      <section
        className="fee-hero"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,35,66,.75), rgba(10,35,66,.75)), url('/images/h.jpeg')",
        }}
      >
        <div className="container">
          <div className="fee-hero-content">
            <span className="section-tag">SAHARA PUBLIC SCHOOL</span>

            <h1>
              School Fee Structure
              <span> 2026–2027</span>
            </h1>

            <p>
              Sahara Public School follows a transparent and affordable fee
              structure that ensures quality education while maintaining
              world-class learning facilities for every student.
            </p>

            <div className="hero-buttons">
              <a href="#fees" className="btn btn-secondary">
  View Fee Structure
</a>

<a href="/admission" className="btn btn-primary">
  Apply Now
</a>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="fee-overview">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">FEE OVERVIEW</span>

            <h2>Affordable Education with Complete Transparency</h2>

            <p>
              Our fee structure is designed to provide high-quality education,
              modern infrastructure, experienced teachers, and holistic
              development while remaining affordable for families across Nepal.
            </p>
          </div>

          <div className="overview-grid">
            <div className="overview-card">
              <div className="overview-icon">🎓</div>

              <h3>Quality Education</h3>

              <p>
                International standard teaching with SEE curriculum and
                experienced faculty.
              </p>
            </div>

            <div className="overview-card">
              <div className="overview-icon">🏫</div>

              <h3>Modern Facilities</h3>

              <p>
                Smart classrooms, laboratories, library, sports facilities, and
                activity-based learning.
              </p>
            </div>

            <div className="overview-card">
              <div className="overview-icon">💳</div>

              <h3>Easy Payment</h3>

              <p>
                Flexible payment options with transparent fee policies and no
                hidden charges.
              </p>
            </div>

            <div className="overview-card">
              <div className="overview-icon">🏆</div>

              <h3>Scholarship Support</h3>

              <p>
                Merit-based scholarships are available for deserving students
                according to school policy.
              </p>
            </div>
          </div>
        </div>
      </section>
      {}

      <section className="fee-section" id="fees">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">CLASS WISE FEES</span>

            <h2>Fee Structure 2026–2027</h2>

            <p>Select your child's class to view the detailed fee structure.</p>
          </div>

          <div className="class-tabs">
            {Object.keys(feeData).map((cls) => (
              <button
                key={cls}

                className={selectedClass === cls ? "active" : ""}

                onClick={() => setSelectedClass(cls)}
              >
                {cls}
              </button>
            ))}
          </div>

          <div className="fee-grid">
            <div className="fee-card">
              <h3>Registration Fee</h3>

              <h2>₹ {feeData[selectedClass].registration}</h2>
            </div>

            <div className="fee-card">
              <h3>Admission Fee</h3>

              <h2>₹ {feeData[selectedClass].admission}</h2>
            </div>

            <div className="fee-card">
              <h3>Annual Fee</h3>

              <h2>₹ {feeData[selectedClass].annual}</h2>
            </div>

            <div className="fee-card">
              <h3>Monthly Tuition</h3>

              <h2>₹ {feeData[selectedClass].tuition}</h2>
            </div>

            <div className="fee-card">
              <h3>Examination Fee</h3>

              <h2>₹ {feeData[selectedClass].exam}</h2>
            </div>

            <div className="fee-card">
              <h3>Transport Fee</h3>

              <h2>₹ {feeData[selectedClass].transport}</h2>
            </div>
          </div>

          <div className="total-fee-card">
            <h4>Estimated Annual Fee</h4>

            <h1>₹ {feeData[selectedClass].total}</h1>

            <p>* Transport charges may vary according to location.</p>
          </div>
        </div>
      </section>
      {}

      <section className="payment-section">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">PAYMENT & SUPPORT</span>

            <h2>Payment Options & Scholarship</h2>

            <p>
              Sahara Public School offers flexible payment options along with
              scholarship opportunities for deserving students to make quality
              education accessible for every family.
            </p>
          </div>

          <div className="payment-grid">
            {}

            <div className="payment-card">
              <div className="payment-icon">💳</div>

              <h3>Payment Methods</h3>

              <ul>
                <li>✔ Cash Payment at School Office</li>

                <li>✔ Bank Deposit / Online Banking</li>

                <li>✔ Mobile Wallet (eSewa / Khalti)</li>

                <li>✔ QR Code Payment</li>

                <li>✔ Semester-wise Installment Facility</li>
              </ul>
            </div>

            {}

            <div className="payment-card">
              <div className="payment-icon">🏆</div>

              <h3>Scholarship Program</h3>

              <ul>
                <li>✔ Merit Based Scholarship</li>

                <li>✔ SEE Topper Scholarship</li>

                <li>✔ Sports Scholarship</li>

                <li>✔ Financial Assistance (Selected Cases)</li>

                <li>✔ Special Talent Scholarship</li>
              </ul>
            </div>

            {}

            <div className="payment-card">
              <div className="payment-icon">📋</div>

              <h3>Fee Policy</h3>

              <ul>
                <li>✔ Fees should be paid before the due date.</li>

                <li>✔ Late payment charges may apply.</li>

                <li>✔ Admission Fee is non-refundable.</li>

                <li>✔ Transport Fee depends on route.</li>

                <li>✔ School reserves the right to revise fees annually.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="fee-contact">
        <div className="container">
          <div className="fee-contact-box">
            <h2>Need Help Regarding Fees?</h2>

            <p>
              Our admission counsellors are happy to assist you with fee
              structure, scholarships, payment plans and admission guidance.
            </p>

            <div className="fee-contact-buttons">
             <a href="/admission" className="btn btn-primary">
  Apply for Admission
</a>

<a href="/contact" className="btn btn-secondary">
  Contact Us
</a>
            </div>
          </div>
        </div>
      </section>
      {}

      <section className="important-notes">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">IMPORTANT INFORMATION</span>

            <h2>Fee Policies & Guidelines</h2>

            <p>
              Please read the following fee guidelines carefully before
              completing the admission process.
            </p>
          </div>

          <div className="notes-grid">
            <div className="note-card">
              <div className="note-icon">📅</div>

              <h3>Payment Schedule</h3>

              <p>
                School fees should be paid before the due date announced by the
                school administration every academic session.
              </p>
            </div>

            <div className="note-card">
              <div className="note-icon">⏰</div>

              <h3>Late Payment</h3>

              <p>
                A late payment charge may be applicable if the fee is not paid
                within the specified due date.
              </p>
            </div>

            <div className="note-card">
              <div className="note-icon">💰</div>

              <h3>Refund Policy</h3>

              <p>
                Admission, registration and annual fees are non-refundable once
                admission has been confirmed.
              </p>
            </div>

            <div className="note-card">
              <div className="note-icon">🚌</div>

              <h3>Transport Charges</h3>

              <p>
                Transport fees depend on the distance and selected school route.
              </p>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="fee-faq">
        <div className="container">
          <div className="section-heading">
            <span className="section-tag">FAQ</span>

            <h2>Frequently Asked Questions</h2>

            <p>
              Find answers to the most commonly asked questions regarding the
              fee structure and payment process.
            </p>
          </div>

          <div className="faq-container">
            <details className="faq-item">
              <summary>Is the admission fee refundable?</summary>

              <p>
                No. Admission and registration fees are non-refundable after
                confirmation of admission.
              </p>
            </details>

            <details className="faq-item">
              <summary>Can I pay the fees in installments?</summary>

              <p>
                Yes. Parents may choose installment payment options according to
                school policy.
              </p>
            </details>

            <details className="faq-item">
              <summary>Are scholarships available?</summary>

              <p>
                Yes. Merit-based and special scholarships are available for
                eligible students.
              </p>
            </details>

            <details className="faq-item">
              <summary>Is transport fee included in the annual fee?</summary>

              <p>
                No. Transport charges are calculated separately based on the
                selected route.
              </p>
            </details>

            <details className="faq-item">
              <summary>Which payment methods are accepted?</summary>

              <p>
                Cash, Bank Transfer, QR Payment, eSewa and Khalti are accepted
                for fee payment.
              </p>
            </details>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeeStructure;
